export enum AuctionType {
    FF = 0,
    Auction,
    ContractStrong,
    ContractFlex,
    ContractDeclined,
    ContractUnAnswered
}